import { styled } from "dripsy";
import { ScrollView as RNScrollView } from "react-native";

const ScrollView = styled(RNScrollView)();
export default ScrollView;
